module.exports = __webpack_public_path__ + "fonts/Aeonik-Bold.81f461c.woff2";